<template>
  <div class="page-information" v-loading="!orderInfo||fullLoading">
    <div class="block-top" v-if="orderInfo">
      <div class="block-left">
        <p class="block-title">{{ $t('My Booking Information') }}</p>
        <div class="block-content">
          <div class="basic-info">
            <p>{{ $t('Welcome back') }}, {{ orderInfo.rooms[0].first_name }} {{ orderInfo.rooms[0].last_name }}!</p>
            <div class="info-content">
              <div class="hotel-info">
                <div class="hotel-img">
                  <img :src="orderInfo.party.img" alt="hotel image">
                </div>
                <div class="texts">
                  <span class="label">{{ $t('Hotel Selection') }}{{ $t(':') }}</span>
                  <strong>{{ orderInfo.rooms[0].hotel_name }}</strong>
                </div>
              </div>
              <div class="duration">
                <div class="texts">
                  <span class="label">{{ $t('Duration') }}{{ $t(':') }}({{ orderInfo.party.number_of_night }} {{
                      $t('Nights')
                    }})</span>
                  <strong>{{ orderInfo.rooms[0].arrival }} {{ $t('to') }} {{ orderInfo.rooms[0].departure }}</strong>
                </div>
              </div>
              <div class="room-guests">
                <div class="texts">
                  <span class="label">{{ $t('Rooms & Guests') }}{{ $t(':') }}</span>
                  <strong v-html=" $t('Rooms & Guests:{0}{1}{2}',
                        [orderInfo.party.number_of_room, orderInfo.rooms[0].adults, orderInfo.rooms[0].children])">
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <div class="info-table">
            <table>

              <tbody v-for="(room,roomIndex) of orderInfo.rooms" :key="roomIndex">

              <tr class="tr-title pc">
                <td class="title">{{ $t('ROOM') }} {{ roomIndex + 1 }} {{ $t('INFORMATION') }}</td>
                <td>{{ $t('Confirmation No.') }}{{ $t(':') }}</td>
                <td>{{ room.order_id }}</td>
              </tr>

              <tr class="mob">
                <td></td>
                <td class="title">{{ $t('ROOM') }} {{ roomIndex + 1 }} {{ $t('INFORMATION') }}</td>
                <td>
                  <span class="cancel"
                        @click="cancel([room.order_id])"
                        v-if="room.can_cancel">{{ $t('Cancel This Room') }}
                  </span>
                </td>
              </tr>

              <tr class="mob">
                <td></td>
                <td>{{ $t('Confirmation No.') }}{{ $t(':') }}</td>
                <td>{{ room.order_id }}</td>
              </tr>

              <tr class="tr-action">
                <td class="pc">
                  <span class="cancel"
                        @click="cancel([room.order_id])"
                        v-if="room.can_cancel">
                    {{ $t('Cancel This Room') }}
                  </span>
                </td>
                <td>{{ $t('Title') }}{{ $t(':') }}</td>
                <td>{{ room.title }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Last Name') }}{{ $t(':') }}</td>
                <td>{{ room.last_name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('First Name') }}{{ $t(':') }}</td>
                <td>{{ room.first_name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Place of Residence') }}{{ $t(':') }}</td>
                <td>{{ room.residence_code | langPlace(currentLang) }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Phone Number') }}{{ $t(':') }}</td>
                <td>{{ room.phone_number }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Email Address') }}{{ $t(':') }}</td>
                <td>{{ room.email }}</td>
              </tr>
              <tr v-if="room.arrival_time">
                <td></td>
                <td>{{ $t('Arrival Time') }}{{ $t(':') }}</td>
                <td>{{ room.arrival_time }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Room Type') }}{{ $t(':') }}</td>
                <td>{{ room.room_group_name }}{{ $t(',') }}{{ room.roomtype_name }}</td>
              </tr>
              <tr>
                <td></td>
                <td>{{ $t('Rate') }}{{ $t(':') }}</td>
                <td>{{ room.rate_name }}</td>
              </tr>

              <tr class="special_request" v-if="room.special_request">
                <td></td>
                <td>{{ $t('Special Request') }}{{ $t(':') }}</td>
                <td>{{ room.special_request }}</td>
              </tr>

              <tr v-if="room.comments">
                <td></td>
                <td>{{ $t('Additional Info') }}{{ $t(':') }}</td>
                <td class="comments"><span>{{ room.comments }}</span></td>
              </tr>


              <tr class="room_status">
                <td></td>
                <td>{{ $t('Status') }}{{ $t(':') }}</td>
                <td>{{ room.status }}</td>
              </tr>

              <tr :class="{'add-ons':packIndex===0}" v-for="(pack,packIndex) of room.packages" :key="packIndex">
                <td :class="{title:packIndex===0}">{{ packIndex === 0 ? $t('ADD-ONS') + ':' : '' }}</td>
                <td>{{ pack.name }}</td>
                <td>{{ pack.quantity }} {{ pack.unit }} ({{ pack.average_price | formatMoney($t(currency)) }} /
                  {{ pack.unit }})
                </td>
              </tr>


              <tr>
                <td colspan="3">
                  <div>
                    <span>{{ $t('Cancellation Policy') }}</span>
                    <div class="cms-style" v-html="room.cancel_remark">
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
      <div class="block-right">
        <p class="block-title">
          {{ $t('Payment Summary') }}
        </p>
        <div class="total">
          <table>
            <tbody v-for="(room,roomIndex) of orderInfo.rooms" :key="roomIndex">
            <tr>
              <td class="title">{{ $t('Room') }} {{ roomIndex + 1 }} {{ $t('Daily Rates') }}{{ $t(':') }}</td>
              <td></td>
            </tr>
            <tr v-for="(price,priceKey,priceIndex) of room.prices" :key="priceIndex">
              <td>{{ priceKey }}{{ $t(':') }}</td>
              <td>{{ price.price | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td class="nbsp"></td>
              <td></td>
            </tr>

            <tr>
              <td class="title">{{ $t('Room') }} {{ roomIndex + 1 }} {{ $t('Charges') }}{{ $t(':') }}</td>
              <td></td>
            </tr>
            <tr>
              <td>{{ $t('Total Room Charges') }}{{ $t(':') }}</td>
              <td>{{ room.room_total_price | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Additional Options') }}{{ $t(':') }}</td>
              <td>{{ room.package_total_price | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

            <tbody class="sub">
            <tr>
              <td>{{ $t('Sub Total') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.party.sub_total | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Service Charge') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.party.service_fee | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Government Tax') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.party.tax_fee | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Grand Total') }}{{ $t(':') }}</td>
              <td>{{ orderInfo.party.total_amount | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

            <tbody class="online">
            <tr>
              <td>{{ $t('Online Payment') }}{{ $t(':') }} <span
                v-if="orderInfo.party.deposit_rule_desc">({{ orderInfo.party.deposit_rule_desc }})</span>
              </td>
              <td>{{ orderInfo.party.online_payment | formatMoney($t(currency)) }}</td>
            </tr>
            <tr>
              <td>{{ $t('Outstanding Balance') }}{{ $t(':') }}<span>({{ $t('Please pay upon check-in') }})</span></td>
              <td>{{ orderInfo.party.offline_payment | formatMoney($t(currency)) }}</td>
            </tr>
            </tbody>

          </table>
        </div>

      </div>
    </div>
    <div class="block-bottom">
      <el-button class="cancel"
                 type="primary"
                 @click="cancel_all"
                 v-if="orderInfo&&orderInfo.party.cancel_all_flag">
        {{ $t('CANCEL ALL BOOKINGS') }}
      </el-button>
      <el-button class="back" type="primary" @click="back">{{ $t('BACK') }}</el-button>
    </div>
  </div>
</template>

<script>
const countries = require('../assets/files/countries.json')
import {mapState} from 'vuex'
import util from "../util";

export default {
  data: function () {
    return {
      orderInfo: '',
      fullLoading: false,
      employee_quota: 0,
      employee_rate: {},
      fnf_quota: 0,
      fnf_rate: {},
    }
  },
  methods: {
    getOrderInfo() {
      if (Object.keys(this.$route.params).length) {
        this.orderInfo = this.$route.params
      } else {
        this.axios.get('/api/employee/order', {params: this.$route.query})
          .then((res) => {
              if (res.code !== 200) {
                this.$alert(res.msg, {
                  confirmButtonText: this.$t('BACK'),
                  center: true,
                  callback: () => {
                    this.$router.push({name: 'UserCenter', query:{skin: this.gaData.skinCode}})
                  }
                }).then(() => {
                  this.$router.push({name: 'UserCenter', query:{skin: this.gaData.skinCode}})
                });
            } else {
                this.orderInfo = res.data
            }
            }
          ).finally()
      }
    },
    cancel(confirmation_numbers) {
      this.$confirm(this.$t('Are you sure you want to cancel the reservation') , {
        confirmButtonText: this.$t('Continue'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.fullLoading = true
        this.axios.post('/api/employee/order/cancel', {confirmation_numbers})
          .then((res) => {
            if (res.code === 200) {
              this.$alert(res.msg, {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
              })
              this.$router.replace('/refresh')
              // 取消预订后刷新额度
              this.getUserInfo(confirmation_numbers)
            } else {
              this.$alert(res.msg, {
                  confirmButtonText: this.$t('CLOSE'),
                  center: true,
              })
            }
          }).finally(() => {
          this.fullLoading = false
        })
      }).catch(() => {
      });
    },
    getUserInfo(confirmation_numbers) {
      confirmation_numbers.map(orderId => {
        this.orderInfo.rooms.map(room => {
          if(orderId == room.order_id) {
            this.employee_quota = localStorage.employee_quota
            this.employee_rate = JSON.parse(localStorage.employee_rate)
            this.fnf_quota = localStorage.fnf_quota
            this.fnf_rate = JSON.parse(localStorage.fnf_rate)
            if(this.employee_rate[room.hotel_code] == room.rate_code) {
              this.employee_quota = +this.employee_quota + this.orderInfo.party.number_of_night
              this.$store.commit('stateChange', {k: 'employeeQuota', v: this.employee_quota})
              localStorage.employee_quota = this.employee_quota
            } else if (this.fnf_rate[room.hotel_code] == room.rate_code) {
              this.fnf_quota = +this.fnf_quota + this.orderInfo.party.number_of_night
              this.$store.commit('stateChange', {k: 'fnfQuota', v: this.fnf_quota})
              localStorage.fnf_quota = this.fnf_quota
            }
          }
        })
      })
    },
    cancel_all() {
      let confirmation_numbers = []
      this.orderInfo.rooms.forEach((room) => {
        {
          confirmation_numbers.push(room.order_id)
        }
      })
      this.cancel(confirmation_numbers)
    },
    back() {
      this.$router.push({
        name: 'UserCenter',
        query: {
            'skin': this.gaData.skinCode
        },
      })
    },
    gaEvent(eventData) {
      const orderInfo = eventData.party
      const roomInfo = eventData.rooms[0]
      let rooms = []

      eventData.rooms.forEach((room) => {
        Object.entries(room.prices).forEach((x) => {
          //room
          let obj = {
            name: room.room_type_name_en + '+' + room.rate_name_en,
            sku: room.roomtype_code + '+' + room.rate_code,
            price: 0,
            quantity: 1,
            tax: 0,
            serviceFee: 0,
            hotel: room.hotel_code,
            date: '',
          }
          obj.date = x[1].date
          obj.price = x[1].price
          obj.tax = +x[1].tax_fee
          obj.serviceFee = +x[1].service_fee
          rooms.push(obj)
        })
      })

      let gaData = {
        currentTimeMacau: localStorage.date || '',
        currentTimeLocal: util.dateStr(new Date(), true),
        currentStep: 5,
        cookieId: '',
        skinCode: this.gaData.skinCode,
        memberLoggedIn: false,
        //step2 data
        checkInDate: roomInfo.check_in_date,
        checkOutDate: roomInfo.check_out_date,
        selectedHotel: roomInfo.hotel_code,
        numberTotalRooms: orderInfo.number_of_room,
        numberTotalAdults: roomInfo.adults,
        numberTotalChild: roomInfo.children,
        numberTotalNights: orderInfo.number_of_night,
        //step3 data
        transactionProducts: rooms,
        //step4 data
        transactionId: roomInfo.order_id,
        transactionTotal: orderInfo.total_amount,
        transactionTax: orderInfo.tax_fee,
        pointsUsed: 0,
        paymentMethod: this.paymentMethod,
        placeOfResidence: roomInfo.residence_name
      }

      window.dataLayer.push(gaData)
      window._mtm.push({"event": "booking data ready"})
    }
  },
  created() {
    //this.$root.$children[0].gaInit()
    this.$store.commit('stateChange', {k: 'currency', v: 'MOP'})
    localStorage.setItem("currency", 'MOP');
    this.getOrderInfo()
  },
  computed: {
    ...mapState(
      ['SearchParams', 'currency', 'dataLayerReady', 'gaData']
    ),
    gaWatcher() {
      const {dataLayerReady, orderInfo} = this
      return {
        dataLayerReady,
        orderInfo
      }
    },
    paymentMethod() {
      let str = 'None'
      let code = this.orderInfo.party.pay_method
      if (+code === 1 || +code === 2) {
        str = 'creditCard'
      } else if (+code === 6) {
        str = 'unionpay'
      } else {
        switch (code) {
          case 'A':
            str = 'alipay';
            break;
          case 'W':
            str = 'wechatPay';
            break;
          case 'N':
            str = 'noPaymentRequired';
            break;
          case 'P':
            str = 'membershipPoints';
        }
      }
      return str
    },
    currentLang() {
      return this.$i18n.locale
    },
  },
  watch: {
    gaWatcher(obj) {
      if (obj.dataLayerReady && obj.orderInfo) {
        this.gaEvent(obj.orderInfo)
      }
    }
  },
  filters: {
    langPlace(code, lang) {
      let place = countries.find(element => element.code === code)[lang]
      if (lang !== 'en') {
        place = place.split(' - ')[1]
      }
      return place
    }
  }
}

</script>
